
/**
 * Utility for managing API keys in localStorage (BYOK architecture).
 * Keys are stored client-side only and passed to serverless functions via headers.
 */

export const ProviderKeys = {
    GEMINI: 'studio_api_key',
    FAL_LTX: 'fal_ltx_api_key',
    HUGGING_FACE: 'huggingface_api_key', // Legacy, kept for potential LTX reference
};

export const getProviderKey = (providerKeyName: string): string | null => {
    if (typeof window === 'undefined') return null;
    // Handle legacy stored keys (the key name itself might be in quotes in some old logic, but standardizing here)
    const stored = localStorage.getItem(providerKeyName);
    // remove quotes if stored as JSON string "key"
    if (stored && stored.startsWith('"') && stored.endsWith('"')) {
        return stored.slice(1, -1);
    }
    return stored;
};

export const setProviderKey = (providerKeyName: string, key: string): void => {
    if (typeof window === 'undefined') return;
    localStorage.setItem(providerKeyName, key);
};

export const clearProviderKey = (providerKeyName: string): void => {
    if (typeof window === 'undefined') return;
    localStorage.removeItem(providerKeyName);
};

export const hasProviderKey = (providerKeyName: string): boolean => {
    return !!getProviderKey(providerKeyName);
};
